module.exports = __webpack_public_path__ + "static/media/BTC-USDC.c4ed6ad6.png";